import React, { useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const InputTypeBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(props.rowData);
    _.set(nextData, "inputtype", "basic");
    _.set(nextData, "freerentdetail", null)
    _.set(nextData, field, val);
    if (!nextData['amttype']) _.set(nextData, 'amttype', props.defaults['freeRentAmtType'])
    if (!nextData['freerentrevtype']) _.set(nextData, 'freerentrevtype', props.defaults['freeRentRevenue'])
    props.persist(nextData, props.field, props.rowData)
  }

  useEffect(() => {}, [props['rowData']])

  const unnested_attrs = (field) => field_attrs('freerent')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>New</label>
          <NumberInput className="automated new-renewal" data={props['rowData']} attrs={unnested_attrs} field="mosnew" readPrecision={4} writePrecision={4} min={0} max={1200} persist={updateData} style={{width: 100}} />
        </div>
        <div>
          <label>Renewal</label>
          <NumberInput className="automated new-renewal" data={props['rowData']} attrs={unnested_attrs} field="mosrenew" readPrecision={4} writePrecision={4} min={0} max={1200} persist={updateData} />
        </div>
        <div>
          <label>Amt Type</label>
          <DropdownInput className="automated" data={props['rowData']} default={props.defaults['freeRentAmtType']} attrs={unnested_attrs} field="amttype" options={['Mos', 'Mos/Yr']} persist={updateData} />
        </div>
        <div>
          <label>Revenue</label>
          <DropdownInput className="automated" data={props['rowData']} default={props.defaults['freeRentRevenue']} attrs={unnested_attrs} field="freerentrevtype" options={['Rent', 'Rent + Recovery', 'All Revenues', 'Recovery']} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default InputTypeBasic